export const config = {
  resize: false,
  star: {
    alpha: {
      start: 1,
      end: 1,
    },
    scale: {
      start: 0.5,
      end: 0.5,
      minimumScaleMultiplier: 1,
    },
    color: {
      start: '#ffffff',
      end: '#ffffff',
    },
    speed: {
      start: 150,
      end: 1,
      minimumSpeedMultiplier: 1,
    },
    acceleration: {
      x: 0,
      y: 0,
    },
    maxSpeed: 0,
    startRotation: {
      min: 0,
      max: 360,
    },
    noRotation: false,
    rotationSpeed: {
      min: 0,
      max: 0,
    },
    lifetime: {
      min: 9,
      max: 9,
    },
    blendMode: 'normal',
    frequency: 0.05,
    emitterLifetime: -1,
    maxParticles: 500,
    pos: {
      x: 0,
      y: 0,
    },
    addAtBack: true,
    spawnType: 'circle',
    spawnCircle: {
      x: 0,
      y: 0,
      r: 0,
    },
  },
  line: {
    alpha: {
      start: 1,
      end: 1,
    },
    scale: {
      start: 0.06,
      end: 0.9,
      minimumScaleMultiplier: 1,
    },
    color: {
      start: '#ffffff',
      end: '#ffffff',
    },
    speed: {
      start: 2,
      end: 5000,
      minimumSpeedMultiplier: 1,
    },
    acceleration: {
      x: 0,
      y: 0,
    },
    maxSpeed: 0,
    startRotation: {
      min: 0,
      max: 360,
    },
    noRotation: false,
    rotationSpeed: {
      min: 0,
      max: 0,
    },
    lifetime: {
      min: 1,
      max: 9,
    },
    blendMode: 'normal',
    frequency: 0.02,
    emitterLifetime: -1,
    maxParticles: 500,
    pos: {
      x: 0,
      y: 0,
    },
    addAtBack: true,
    spawnType: 'circle',
    spawnCircle: {
      x: 0,
      y: 0,
      r: 30,
    },
  },
}
